import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addSubscription, updateSubscription } from '../Services/subscriptionService';
import { toast } from 'react-toastify';

export const useSaveSubscription = ({ onSuccess, onError, onSettled } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (formData) => {
            if (formData.subscriptionId) {
                return updateSubscription(formData);
            } else {
                return addSubscription(formData);
            }
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries(['subscriptions']);
            toast.success("Subscription saved successfully");
            if (onSuccess) onSuccess(data, variables, context);
        },
        onError: (error, variables, context) => {
            toast.error(error?.response?.data?.status?.message ?? "Internal Server Error");
            if (onError) onError(error, variables, context);
        },
        onSettled: (data, error, variables, context) => {
            if (onSettled) onSettled(data, error, variables, context);
        },
    });
};
